
































































































import {
    ESearch,
    Pagination,
    Scrollbar,
    SvgImage,
    TailwindTableTabs,
    CardLayout,
    Sort,
    CardLayoutCard,
    CardLayoutCardSkeleton,
} from '@/app/components';
import { PlusIcon, PencilAltIcon, TrashIcon } from '@vue-hero-icons/outline';
import { computed, defineComponent, ref } from '@vue/composition-api';
import { ConfirmModal } from '@/app/components';
import { ScalingSquaresSpinner as OrbitSpinner } from 'epic-spinners';
import { useRetrievalQueries } from '../composable';
import { RetrievalStatus } from '../constants';

export default defineComponent({
    name: 'RetrievalQueries',
    metaInfo: { title: 'Retrieval' },
    components: {
        PlusIcon,
        OrbitSpinner,
        Pagination,
        CardLayout,
        CardLayoutCard,
        CardLayoutCardSkeleton,
        SvgImage,
        Scrollbar,
        Sort,
        TailwindTableTabs,
        ESearch,
        ConfirmModal,
    },
    setup(props, { root }) {
        const pageSize = 48;
        const showDeleteModal = ref(false);
        const selectedQuery = ref(null);

        const statusMap = {
            AVAILABLE: {
                label: 'Available',
                background: 'bg-green-800',
                text: 'text-green-100',
            },
            DRAFT: {
                label: 'Draft',
                background: 'bg-blue-800',
                text: 'text-blue-100',
            },
            DEPRECATED_ASSET: {
                label: 'Deprecated',
                background: 'bg-gray-600',
                text: 'text-gray-100',
            },
            NO_ACCESS: {
                label: 'Unavailable',
                background: 'bg-red-800',
                text: 'text-red-100',
            },
        };

        const searchableFields = [
            {
                label: 'title',
                key: 'title',
                textColorClasses: 'text-primary-700',
                backgroundClasses: 'bg-primary-700',
                highlightClasses: 'bg-primary-300',
                widthClasses: 'pl-16 ml-2',
            },
            {
                label: 'description',
                key: 'description',
                textColorClasses: 'text-teal-700',
                backgroundClasses: 'bg-teal-700',
                highlightClasses: 'bg-teal-300',
                widthClasses: 'pl-28 ml-2',
            },
        ];

        const retrievalQueryStatuses = computed(() => {
            return [
                { label: 'All', key: 'all' },
                ...Object.keys(RetrievalStatus).map((statusLabel: string) => {
                    return {
                        label: statusLabel,
                        key: RetrievalStatus[statusLabel],
                    };
                }),
            ];
        });

        const {
            page,
            query,
            retrievalQueries,
            loading,
            totalResults,
            tab,
            sortBy,
            deleteRetrievalQuery,
            updateCurrentPage,
            sortByChanged,
            setTab,
            sortingFields,
            errors,
        } = useRetrievalQueries(root, 'retrieval', pageSize);

        const deleteQuery = () => {
            if (selectedQuery.value) {
                deleteRetrievalQuery(selectedQuery.value)
                    .then(() => {
                        (root as any).$toastr.s(`Retrieval Query successfully deleted`, 'Successful deletion!');
                    })
                    .catch((error) => {
                        (root as any).$toastr.e(error, 'Validation error');
                    });
                showDeleteModal.value = false;
                selectedQuery.value = null;
            }
        };

        const actions = (retrievalQuery: any) => {
            return [
                {
                    id: '1',
                    label: 'Edit',
                    icon: PencilAltIcon,
                    to: { name: 'retrieval:edit', params: { id: retrievalQuery.id } },
                },
                {
                    id: '3',
                    label: 'Delete',
                    icon: TrashIcon,
                    tooltip: 'Delete asset',
                    click: () => {
                        selectedQuery.value = retrievalQuery;
                        showDeleteModal.value = true;
                    },
                },
            ];
        };

        return {
            tab,
            page,
            pageSize,
            loading,
            retrievalQueries,
            totalResults,
            sortingFields,
            retrievalQueryStatuses,
            query,
            sortBy,
            deleteQuery,
            updateCurrentPage,
            setTab,
            sortByChanged,
            searchableFields,
            errors,
            showDeleteModal,
            statusMap,
            actions,
        };
    },
});
